import { State, Action, StateContext, Selector } from '@ngxs/store';
import { LayoutActions } from './layout.actions';
import { LayoutStateModel } from './layout.state.model';
import { LayoutThemeEnum } from '../models/layout-theme.enum';
import { Injectable } from '@angular/core';
import { SiteHeaderType } from '../models/site-header-type.enum';
import { SiteFooterType } from '../models/site-footer-type.enum';

const initialState: LayoutStateModel = {
  theme: LayoutThemeEnum.Light,
  sidenav: {
    enabled: true,
    open: false,
  },
  siteHeader: SiteHeaderType.Application,
  siteFooter: SiteFooterType.None,
};

@State<LayoutStateModel>({
  name: 'layout',
  defaults: initialState,
})
@Injectable()
export class LayoutState {
  @Selector()
  static getTheme(state: LayoutStateModel) {
    return state.theme;
  }

  @Selector()
  static getSidenav(state: LayoutStateModel) {
    return state.sidenav;
  }

  @Selector()
  static getSiteHeader(state: LayoutStateModel) {
    return state.siteHeader;
  }

  @Selector()
  static getSiteFooter(state: LayoutStateModel) {
    return state.siteFooter;
  }

  @Action(LayoutActions.SetTheme)
  setTheme({ patchState }: StateContext<LayoutStateModel>, { theme }: LayoutActions.SetTheme) {
    patchState({
      theme: theme,
    });
  }

  @Action(LayoutActions.SetHeader)
  setHeader(context: StateContext<LayoutStateModel>, action: LayoutActions.SetHeader) {
    context.patchState({
      siteHeader: action.siteHeaderType,
    });
  }

  @Action(LayoutActions.SetFooter)
  setFooter(context: StateContext<LayoutStateModel>, action: LayoutActions.SetFooter) {
    context.patchState({
      siteFooter: action.siteFooterType,
    });
  }

  @Action(LayoutActions.SetSidenav)
  setSidenav(context: StateContext<LayoutStateModel>, action: LayoutActions.SetSidenav) {
    context.patchState({
      sidenav: {
        ...action.sidenav,
      },
    });
  }

  @Action(LayoutActions.ToggleSidenav)
  toggleSidenav(context: StateContext<LayoutStateModel>, action: LayoutActions.ToggleSidenav) {
    const sidenav = context.getState().sidenav;
    context.patchState({
      sidenav: {
        ...sidenav,
        open: action.open,
      },
    });
  }

  @Action(LayoutActions.ResetLayout)
  resetLayout(context: StateContext<LayoutStateModel>, action: LayoutActions.ResetLayout) {
    context.setState(initialState);
  }
}
